import 'leaflet/dist/leaflet.css'
import './MachineTypeMap.css'

import React, { useEffect, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L, { LatLngExpression } from 'leaflet'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import { useNavigate } from 'react-router-dom'
import { useModal } from '../modal/Modal'
import { defaultMapCenter } from '@/env/config'
import { MapPopupBody, MapRow } from './Map'
import { getCategoryNameByItem } from '@/services/repository/machineTypes'

const vehicleIconSize = 60

export function vehicleClass(row: MapRow): string {
  return 'map-point-vehicletype-ring'
}

export function vehicleElement(row: MapRow): string {
  return `<div class="${vehicleClass(row)}">`
    + `<img src="/public/img/map/machinetype/${getCategoryNameByItem(row.machine.type.category)}.svg" />` +
    `</div>`
}

export function vehicleObject(row: MapRow): object {
  var halfVehicleIconSize = vehicleIconSize/2
  return {
    className: 'car-icon',
    html: vehicleElement(row),
    iconSize: [vehicleIconSize, vehicleIconSize], // Adjust size as needed
    iconAnchor: [halfVehicleIconSize, halfVehicleIconSize], // Anchor point
  }
}

export const MachineTypeMapComponent = ({ services, session, rows }: {
  services: Services,
  session: CurrentSession
  // fetchUrl: string
  rows: MapRow[] | undefined
}) => {
  const navigate = useNavigate()
  const { openModal } = useModal()
  const [myposition, setMyPosition] = useState<[number, number] | undefined>(undefined)

  useEffect(() => {
    // Function to handle geolocation success
    const handleSuccess = (location: GeolocationPosition) => {
      const { latitude, longitude } = location.coords
      setMyPosition([latitude, longitude])
    }

    // Function to handle geolocation error
    const handleError = (error: GeolocationPositionError) => {
      console.error('Error obtaining location:', error)
      // Fallback to a default position if geolocation fails
      setMyPosition(undefined)
    }

    // Check if geolocation is available
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(handleSuccess, handleError)
    } else {
      console.error('Geolocation is not supported by this browser.')
      // Fallback to a default position if geolocation is not supported
      setMyPosition(undefined)
    }
  }, [])

  if (rows === undefined) {
    return <div className='spinner'></div>
  }

  function findLatestRow(rows: MapRow[]): MapRow | undefined {
    if (!rows || rows.length === 0) {
      return undefined;
    }

    return rows.reduce((latest, current) => {
      return new Date(current.dtTracker) > new Date(latest.dtTracker) ? current : latest;
    });
  }

  const firstRow = findLatestRow(rows);

  const center: LatLngExpression = (firstRow && {
    lat: firstRow.lat,
    lng: firstRow.lng
  }) || myposition || defaultMapCenter

  return (
    <MapContainer attributionControl={false} center={center} zoom={17} style={{ height: '100%', width: '100%' }} preferCanvas={true}>
      <TileLayer
        attribution='evoltag.pl'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      {rows?.map((row, i) => <Marker
        key={row.imei}
        position={row}
        icon={L.divIcon(vehicleObject(row))} >
        <Popup>
          <MapPopupBody row={row} services={services} session={session} />
        </Popup>
      </Marker>)}

      {myposition ? <Marker
        key='my-location'
        position={myposition}
        icon={L.divIcon({
          className: 'car-icon',
          html: `<img src="/public/img/gps/i_am_here.png" style="width: 32px; margin: -16px auto auto 0px" />`,
          iconSize: [32, 32], // Adjust size as needed
          iconAnchor: [16, 16], // Anchor point
        })}></Marker> : null}
    </MapContainer>
  )
}

